import Image, { type ImageProps } from '2-core-elements/Image/Image';
import { removeBrandPrefixFromLabel } from 'utils/string';

export interface SearchItemTagProps {
    label: string;
}

export type SearchItemProps = {
    img?: Pick<ImageProps, 'imgSrc' | 'imgAlt' | 'imgHeight' | 'imgWidth'>;
    link?: { href: string; label?: string; target?: '_self' | '_blank' };
    title: string;
    subtitle?: string;
    tags?: SearchItemTagProps[];
    children?: React.ReactNode;
    onClick?: () => void;
};

const SearchItem = ({
    img,
    link = { href: '', label: '', target: '_self' },
    title,
    subtitle,
    tags,
    children,
    onClick,
}: SearchItemProps): JSX.Element => {
    const titleToRender = removeBrandPrefixFromLabel(title);
    return (
        <a href={link.href} className={`search-item`} onClick={onClick}>
            <div className="item-content">
                <h3 className="item-title">
                    {titleToRender}
                </h3>
                {subtitle && (
                    <p className="item-subtitle">{subtitle}</p>
                )}
                {children && (
                    <div className="item-description">
                        {children}
                    </div>
                )}
                {!!tags?.length && (
                    <div className="item-tags">
                        {tags.map((props, i) => {
                            const key = `${props.label}-${i}`;

                            const labelToRender = removeBrandPrefixFromLabel(props.label);

                            return (
                                <div key={key} className="item-tag">
                                    {labelToRender}
                                </div>
                            );
                        })}
                    </div>
                )}
            </div>
            {img && (
                <div className="item-img">
                    <Image imgSrc={img.imgSrc} imgAlt={img.imgAlt} />
                </div>
            )}
        </a>
    );
};

export default SearchItem;
